// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1opJA","itemTitle":"ClientEmergencyInfo_itemTitle__1WMBy","itemText":"ClientEmergencyInfo_itemText__3o8yJ"};